import React from 'react'
import Matresses from './Images/matresses.jpg';
import Furniture from './Images/bedroom_items.jpg';
import Clothes from './Images/sch-uniform.jpg';
import SS from './Images/books.jpg';
import Stationary from './Images/student_stationary.jpg';

function Cartegories({setAbout}) {

  const more_btn = () =>{
     setAbout(true)
   // alert('jj')
  }
  return (
    <div className='cartegories_PICS'>
        
        <div className='cartegory_main'>
         <div className='cartegories_IMG_DIV'>
          <img src={Matresses} />
         </div>
           <p className='cartegories_DESC'>Matresses</p> 
        </div>

        <div className='cartegory_main'>
         <div className='cartegories_IMG_DIV'>
          <img src={SS} />
         </div>
           <p className='cartegories_DESC'>Books</p> 
        </div>

         <div className='cartegory_main'>
         <div className='cartegories_IMG_DIV'>
          <img src={Stationary} />
         </div>
           <p className='cartegories_DESC'>Stationary</p> 
        </div>


        <div className='cartegory_main'>
         <div className='cartegories_IMG_DIV'>
          <img src={Clothes} />
         </div>
           <p className='cartegories_DESC'>Uniforms</p> 
        </div>

        <div className='cartegory_main'>
         <div className='cartegories_IMG_DIV'>
          <img src={Furniture} />
         </div>
           <p className='cartegories_DESC'>Bedroom Items</p> 
        </div>

        
        <div onClick={more_btn} className='more_btn'>
         +more
        </div>
  

    </div>
  )
}

export default Cartegories